
import { useEffect, useState } from 'react'
import { Typography, Avatar, Divider, List, ListItem, ListItemAvatar, ListItemText, IconButton, TextField, MenuItem, Button, Card, DialogActions, Tooltip, Collapse, ListItemIcon, ListItemButton } from '@mui/material'
import api from '../../../../../services/api';
import Mes from '../../../../../utils/mes';
import Loading from '../../../../../load/loading';
import { useDispatch, useSelector } from 'react-redux';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import MessageAlert from '../../../../../messages/messageAlert';
import LoadingBackdrop from '../../../../../load/loadingBackdrop';
import HeaderGestorConfigs from '../../../../../utils/headerGestorConfigs';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
// import FilePresentIcon from '@mui/icons-material/FilePresent';
import ZoomOutMapIcon from '@mui/icons-material/ZoomOutMap';
import { useNavigate } from 'react-router-dom';
import ReprovarInspeccaoRealizada from './reprovarInspeccaoRealizada';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import compressImage from '../../../../../services/compressImage';
import LoadingShort from '../../../../../load/loadingShort';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import RemoverInspector from './removerInspector';
import DeleteImageInspeccao from './deleteImageInspeccao';
import ButtonLeft from '../../../../../utils/buttonLeft';
import PreviewAnexos from '../../../../../utils/PreviewAnexos';
import EnviarNotificacao from '../../../../../utils/enviarNotificacao';


export default function CardInspeccao({ generatePDF, thisInspeccao, viewRelatorio, setRefresh }) {
    // status é uma variavel que indica se inspeccao esta aberta ou fechada
    const [openImagensCapturadas, setOpenImagensCapturadas] = useState(false);
    const user = useSelector(state => state.account.user);
    const [inspeccao, setInspeccao] = useState(thisInspeccao);
    const [inspector, setInspector] = useState('');
    const [admins, setAdmins] = useState('');
    const [addInspector, setAddInspector] = useState(false);
    const [addOutrosInspector, setAddOutrosInspector] = useState(false);
    const [messageSuccess, setMessageSuccess] = useState('');
    const [messageError, setMessageError] = useState('');
    const [load, setLoad] = useState(false);
    const [loadAddImage, setLoadAddImage] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [previewFiles, setPreviewFiles] = useState([]);
    const [currentFileIndex, setCurrentFileIndex] = useState(0);
    const [previewOpen, setPreviewOpen] = useState(false);
    const [openEnviarNotificao, setOpenEnviarNotificacao] = useState('');

    const handleOpenPreview = (documents, fileIndex = 0) => {
        const valid = documents.filter((d) => typeof d === "string" && d.trim() !== "");
        if (!valid.length) return;
        setPreviewFiles(valid);
        setCurrentFileIndex(fileIndex);
        setPreviewOpen(true);
    };

    const handleClosePreview = () => setPreviewOpen(false);

    const handleNavigate = (index) => {
        if (index >= 0 && index < previewFiles.length) {
            setCurrentFileIndex(index);
        }
    };

    useEffect(() => {
        api.get('/admins?funcao=Inspector&perPage=200')
            .then(response => {
                setAdmins(response.data.Admins)
            }).catch(err => '')
    }, [])

    function HandleChange(e) {

        e.target.files ?
            setInspector({ ...inspector, [e.target.name]: e.target.files[0] })
            :
            setInspector({ ...inspector, [e.target.name]: e.target.value })
    }

    // FUNÇÃO PARA ADICIONAR INSPECTOR DA ARMED NA INSPECCAO, ONDE O USUÁRIO PODE SELECIONAR UM INSPECTOR DA LISTA DE ADMINS QUE SÃO INSPECTORES, PARA ADICIONAR NA INSPEÇÃO E TER UM REGISTRO DE QUEM REALIZOU A INSPEÇÃO
    const HandleAddInspector = async () => {
        setLoad(true)
        setMessageSuccess('')
        setMessageError('')

        await api.patch('/inspeccao/add-inspector',
            {
                ...inspector,
                inspeccaoId: inspeccao._id,
                userId: user._id
            })
            .then(res => {
                setLoad(false)
                setMessageSuccess(res.data.msg)
                setAddInspector(false)
                setInspeccao(res.data.inspeccao)

                // enviar e-mail de notificação de andamento do processo
                // senEmail()

            }).catch(err => {
                setLoad(false)
                setMessageError(err.response.data.message)
            })
    }

    // FUNÇÃO PARA ADICIONAR OUTROS INSPECTORES QUE NÃO SÃO DA ARMED, ONDE O USUÁRIO PODE ADICIONAR O NOME, FUNÇÃO E INSTITUIÇÃO DO INSPECTOR, PARA TER UM REGISTRO MAIS COMPLETO DA INSPEÇÃO
    const HandleAddOutrosInspector = async () => {
        setLoad(true)
        setMessageSuccess('')
        setMessageError('')

        await api.patch('/inspeccao/add-outros-inspectores',
            {
                ...inspector,
                inspeccaoId: inspeccao._id,
                userId: user._id
            })
            .then(res => {
                // console.log(res)
                setLoad(false)
                setMessageSuccess(res.data.msg)
                setAddOutrosInspector(false)
                setInspeccao(res.data.inspeccao)

                // enviar e-mail de notificação de andamento do processo
                // senEmail()

            }).catch(err => {
                setLoad(false)
                setMessageError(err.response.data.message)
            })
    }

    // INICIAR MODO DE INSPECCAO, ONDE O USUÁRIO É REDIRECIONADO PARA UMA PÁGINA ESPECÍFICA PARA REALIZAR A INSPEÇÃO, ONDE PODERÁ ADICIONAR OBSERVAÇÕES, FOTOS E OUTROS DETALHES DA INSPEÇÃO EM TEMPO REAL
    const startInspeccao = () => {
        dispatch({
            type: 'inspeccao',
            payload: {
                inspeccao: inspeccao
            }
        })
        navigate(`/admin/modo-inspeccao/${inspeccao.estabelecimento._id} `)
    }

    // QUANDO AS IMPECCOES NAO FOREM COMCLUIDAS OU FECHADAS, AO VOLTAR A FAZER DEVE SE REINICIAR
    async function reiniciarInspeccao() {
        setLoad(true)
        await api.patch('/inspeccao/reiniciar', {
            inspeccaoId: inspeccao._id,
            userId: user._id,
        }).then(res => {
            setInspeccao(res.data.inspeccao)
        }).catch(error => {
            // console.log(error)
            setMessageError(error.response.data.message)
        }).finally(() => setLoad(false))
    }

    // FUNÇÃO PARA ADICIONAR IMAGEM NA INSPECCAO, ONDE A IMAGEM É COMPRIMIDA ANTES DE SER ENVIADA PARA O BACKEND, PARA OTIMIZAR O TEMPO DE ENVIO E O ESPAÇO DE ARMAZENAMENTO
    async function postImage(e) {

        setLoadAddImage(true)
        let imageComprimida = await compressImage(e.target.files[0])

        const formData = new FormData();
        formData.append('fotos', imageComprimida);
        formData.append('inspeccaoId', inspeccao?._id);
        formData.append('userId', user?._id);

        await api.patch(`/inspeccao/add-fotos`, formData)
            .then(response => {
                setLoadAddImage(false)
                setRefresh(response)
                // console.log(response)

                dispatch({
                    type: 'alert',
                    payload: { alert: 'Imagem foi adicionada.!' },
                });

            }).catch(err => {
                setLoadAddImage(false)
                // console.log(err)
            })
    }

    // COMPONENTE PARA CAPTURAR IMAGEM, ONDE O USUÁRIO PODE SELECIONAR UMA IMAGEM DO SEU DISPOSITIVO PARA ADICIONAR NA INSPEÇÃO, E ENQUANTO A IMAGEM ESTIVER SENDO ENVIADA PARA O BACKEND, É EXIBIDO UM LOADING NO LUGAR DO ICONE DE CAPTURA DE IMAGEM
    const CaptureImage = () => {
        return (
            <>
                <IconButton title='Adicionar mais imagens' size='large' style={{ marginLeft: '95%' }} >
                    {loadAddImage ? <LoadingShort />
                        :
                        <label htmlFor="capitureImage" >
                            <CameraAltIcon />
                        </label>
                    }
                </IconButton>
                <input accept="image/png, image/jpg, image/jpeg" type="file" name="foto" id="capitureImage" style={{ display: 'none' }} onChange={postImage} />
            </>
        )
    }

    return (
        inspeccao
            ?
            <>
                {messageSuccess && <MessageAlert message={messageSuccess} type={'success'} />}
                <LoadingBackdrop open={load} text={load} />
                {messageError && <MessageAlert message={messageError} type={'error'} />}

                <Card style={{ padding: 15, borderRadius: 5 }}>
                    <Typography marginX={2} >Estado: {inspeccao.status}</Typography>

                    {inspeccao.status === "Não Realizada" &&
                        <>
                            <Typography>
                                <CalendarMonthIcon />
                                Para mês de <Mes mes={inspeccao.dataAgendada?.mes} />
                            </Typography>
                            <HeaderGestorConfigs title={`Inspecção agendada para o dia ${inspeccao.dataAgendada?.dia} de ${inspeccao.dataAgendada?.mes} as ${inspeccao.dataAgendada?.hora < 10 ? 0 : ''}${inspeccao.dataAgendada?.hora}:${inspeccao.dataAgendada?.minuto < 10 ? 0 : ''}${inspeccao.dataAgendada?.minuto}`} />
                        </>
                    }

                    <div style={{ padding: 10, position: 'relative' }}>

                        {(inspeccao.status === "Realizada" || inspeccao.status === "Reprovada" || inspeccao.status === "Reprovada") &&
                            <>
                                {/* REPROVAR INSPECCAO REALIZADA */}
                                {((user?.funcao === 'Chefe de Departamento' || user?.funcao === 'CNP') && !inspeccao?.estabelecimento?.approved) &&
                                    <ReprovarInspeccaoRealizada inspeccao={inspeccao} />
                                }

                                <Tooltip title="Abrir Relatório">
                                    <Button onClick={() => generatePDF('print')}>
                                        <ZoomOutMapIcon />
                                    </Button>
                                </Tooltip>

                                {viewRelatorio &&
                                    <iframe
                                        id="pdfIframe"
                                        title={`PDF Viewer`}
                                        src={viewRelatorio}
                                        width="100%"
                                        height="800px"
                                        style={{ border: 'none' }}
                                    />
                                }

                                {/* LISTA DE IMAGENS CAPTURADAS */}
                                <List
                                    sx={{ width: '100%', minWidth: '100%', bgcolor: 'background.paper' }}
                                    component="nav"
                                    aria-labelledby="nested-list-subheader"
                                >
                                    <ListItemButton>
                                        <ListItemIcon onClick={() => handleOpenPreview(inspeccao.fotos, 0)}>
                                            {/* <CameraAltIcon /> */}
                                            {inspeccao.fotos.map((foto, index) =>
                                                index < 10 &&
                                                <Avatar
                                                    key={index}
                                                    variant='square'
                                                    id={index}
                                                    src={foto}
                                                    style={{ margin: 5 }}
                                                />
                                            )}
                                        </ListItemIcon>
                                        <ListItemText primary="IMAGENS CAPTURADAS" />
                                        {openImagensCapturadas ?
                                            <IconButton onClick={(e) => {
                                                e.stopPropagation();
                                                setOpenImagensCapturadas(!openImagensCapturadas)
                                            }}><ExpandLess /></IconButton>
                                            : <IconButton onClick={(e) => {
                                                e.stopPropagation();
                                                setOpenImagensCapturadas(!openImagensCapturadas)
                                            }}><ExpandMore /></IconButton>}
                                    </ListItemButton>

                                    {/* ADICIONAR MAIS IMAGENS NA INSPECCAO */}
                                    {!inspeccao?.estabelecimento?.approved && <CaptureImage />}

                                    <Collapse in={openImagensCapturadas} timeout="auto" unmountOnExit>

                                        {inspeccao.fotos.map((foto, index) =>
                                            <div key={index} style={{ position: 'relative' }} onClick={() => handleOpenPreview([inspeccao?.foto], index)}>
                                                {!inspeccao?.estabelecimento?.approved &&
                                                    <DeleteImageInspeccao
                                                        index={index}
                                                        inspeccaoId={inspeccao?._id}
                                                        setMessageSuccess={setMessageSuccess}
                                                        setMessageError={setMessageError}
                                                        setRefresh={setRefresh}
                                                    />
                                                }
                                                <img id={index} src={foto} style={{ marginBottom: 10 }} />
                                            </div>
                                        )}

                                        <DialogActions>
                                            <IconButton onClick={(e) => {
                                                e.stopPropagation();
                                                setOpenImagensCapturadas(!openImagensCapturadas)
                                            }}>
                                                <ExpandLess /> </IconButton>
                                        </DialogActions>
                                    </Collapse>

                                    <PreviewAnexos
                                        files={previewFiles}
                                        currentIndex={currentFileIndex}
                                        isOpen={previewOpen}
                                        onClose={handleClosePreview}
                                        onNavigate={handleNavigate}
                                        inspeccao={inspeccao}
                                        setMessageSuccess={setMessageSuccess}
                                        setMessageError={setMessageError}
                                        setRefresh={setRefresh}
                                    />
                                </List>
                            </>
                        }

                        <Typography marginTop={5}>
                            Inspectores da ARMED
                        </Typography>

                        <List sx={{ width: '100%' }}>
                            {inspeccao.inspectores.map((inspector, index) => (

                                <ListItem key={inspector._id} >
                                    <ListItemAvatar>
                                        <Avatar src={inspector?.dadosPessoais?.fotoURL} style={{ marginRight: 5 }} />
                                    </ListItemAvatar>
                                    <ListItemText primary={inspector?.dadosPessoais?.nome} secondary={index === 0 && 'Inspector Principal'} />

                                    {/* ENVIAR NOTIFICACAO AO INSPECTOR */}
                                    <Button onClick={() => setOpenEnviarNotificacao(inspector?.dadosPessoais?.email)} >Notificar</Button>

                                    {((user?.funcao === 'Chefe de Departamento' || user?.funcao === 'CNP') && !inspeccao?.estabelecimento?.approved && inspeccao.inspectores.length > 1) &&
                                        <RemoverInspector
                                            setMessageSuccess={setMessageSuccess}
                                            setMessageError={setMessageSuccess}
                                            inspectorId={inspector._id}
                                            inspeccaoId={inspeccao._id}
                                            setRefresh={setRefresh}
                                        />
                                    }
                                </ListItem>
                            ))}

                            {inspeccao.status === "Não Realizada" &&
                                <ListItem >
                                    <ListItemAvatar>
                                        <IconButton onClick={() => setAddInspector(!addInspector)}>
                                            <PersonAddAlt1Icon />
                                        </IconButton>
                                    </ListItemAvatar>
                                    <ListItemText primary='' secondary='Adicionar mais inspector' />
                                </ListItem>
                            }
                        </List>


                        {addInspector &&
                            <>
                                <TextField
                                    margin='normal'
                                    required
                                    type="text"
                                    label="Selecionar Inspector"
                                    select
                                    fullWidth
                                    size="small"
                                    name="inspectorId"
                                    variant="outlined"
                                    onChange={HandleChange}
                                    defaultValue={''}
                                >
                                    {admins &&
                                        admins.map((admin) => (
                                            <MenuItem key={admin._id} value={admin._id} >
                                                <Avatar src={admin.dadosPessoais?.fotoURL} style={{ marginRight: 5 }} />
                                                {admin.dadosPessoais?.nome} - <b> {admin.dadosPessoais?.provincia}, {admin.dadosPessoais?.municipio}</b>
                                            </MenuItem>
                                        ))}
                                </TextField>
                                <ButtonLeft funcao={HandleAddInspector} title={'Adicionar'} >
                                    <Button color='error' onClick={() => setAddInspector(false)} >Cancelar</Button>
                                </ButtonLeft>
                            </>
                        }
                    </div>

                    <Divider />

                    <div style={{ padding: 10 }}>
                        <Typography>
                            Outros Inspectores
                        </Typography>
                        <List sx={{ width: '100%' }}>
                            {inspeccao.outrosInspectores.map((inspector) => (

                                <ListItem key={inspector._id} >
                                    {/* <ListItemAvatar>
                                        <Avatar src={inspector?.fotoURL} style={{ marginRight: 5 }} />
                                    </ListItemAvatar> */}
                                    <ListItemText primary={inspector?.nome} secondary={inspector?.instituicao + ' - ' + inspector?.funcao} />
                                </ListItem>
                            ))}

                            {inspeccao.status === "Não Realizada" &&
                                <ListItem >
                                    <ListItemAvatar>
                                        <IconButton onClick={() => setAddOutrosInspector(!addOutrosInspector)}>
                                            <PersonAddAlt1Icon />
                                        </IconButton>
                                    </ListItemAvatar>
                                    <ListItemText primary='' secondary='Adicionar mais inspector' />
                                </ListItem>
                            }
                        </List>
                        {addOutrosInspector &&
                            <>
                                <TextField
                                    required
                                    type="text"
                                    fullWidth
                                    label="Nome"
                                    size="small"
                                    name="nome"
                                    variant="outlined"
                                    onChange={HandleChange}
                                />

                                <TextField
                                    required
                                    margin='normal'
                                    type="text"
                                    label="Função"
                                    fullWidth
                                    size="small"
                                    name="funcao"
                                    variant="outlined"
                                    onChange={HandleChange}
                                />

                                <TextField
                                    required
                                    type="text"
                                    label="Instituição"
                                    fullWidth
                                    size="small"
                                    name="instituicao"
                                    variant="outlined"
                                    onChange={HandleChange}
                                />

                                <ButtonLeft funcao={HandleAddOutrosInspector} title={'Adicionar'} >
                                    <Button color='error' onClick={() => setAddOutrosInspector(false)} >Cancelar</Button>
                                </ButtonLeft>
                            </>
                        }
                    </div>

                    <DialogActions>
                        <Typography> {inspeccao?.estabelecimento.nome}  </Typography>
                        {(inspeccao.status === "Não Realizada") && <Button variant='outlined' onClick={startInspeccao} >Iniciar modo Inspecção</Button>}
                        {inspeccao.status === "Iniciada" && <Button variant='outlined' onClick={reiniciarInspeccao} >Reiniciar Inspecção</Button>}
                    </DialogActions>
                </Card>


                <EnviarNotificacao
                    estabelecimento={inspeccao?.estabelecimento}
                    openReenviarEmail={openEnviarNotificao}
                    setOpenReenviarEmail={setOpenEnviarNotificacao}
                    setMessageSuccess={setMessageSuccess}
                    setMessageError={setMessageError}
                    email={openEnviarNotificao}
                />
            </>
            :
            <Loading />
    );
}
